import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { Theme, useTheme } from "@mui/material/styles";
import { FormHelperText } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

type optionTyps = {
  value: string | number;
  label: string;
};

interface IProps {
  label: string;
  value: string[];
  options: optionTyps[];
  errorMessage?: string | boolean;
  sx?: React.CSSProperties;
  renderValue?: (value: string[]) => React.ReactNode;
  handleChange: (event: any) => void;
}

function getStyles(name: string, values: optionTyps[], theme: Theme) {
  return {
    fontWeight: values.map(({ label }) => label).includes(name)
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
  };
}

export default function MultipleSelect({
  value,
  options,
  label,
  errorMessage,
  sx,
  renderValue,
  handleChange,
}: IProps) {
  const theme = useTheme();

  return (
    <FormControl variant="standard" sx={sx} error={Boolean(errorMessage)}>
      <InputLabel id={`${label}-multiple-name-label`}>{label}</InputLabel>
      <Select 
        displayEmpty 
        labelId={`${label}-multiple-name-label`}
        id={`multiple-select-${label}`}
        value={value}
        multiple={true}
        onChange={handleChange}
        MenuProps={MenuProps}
        renderValue={renderValue}
      >
        {options.map((name: optionTyps) => (
          <MenuItem
            key={name.label}
            value={name.value}
            style={getStyles(name.label, options, theme)}
          >
            {name.label}
          </MenuItem>
        ))}
      </Select>
      {Boolean(errorMessage) && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
}
